const EXCLUDED_FIELDS = [
  'newPossibleField',
  'newPossibleField2',
  'distanceToAirportInKilometers',
  'transferTimeinMinutes',
  'takesKeys',
  'isUnderground',
  'isOutside'
]

const PRIORITY_FACILITIES = ['freeTransfer']

const getFacilities = (parkingFeatures: Record<string, any>): string[] => {
  const facilities = Object.entries(parkingFeatures)
    .filter(
      ([key, value]) =>
        typeof value === 'boolean' &&
        value === true &&
        !EXCLUDED_FIELDS.includes(key)
    )
    .map(([key]) => key)

  return facilities.sort((a, b) => {
    const aIndex = PRIORITY_FACILITIES.indexOf(a)
    const bIndex = PRIORITY_FACILITIES.indexOf(b)

    if (aIndex !== -1 && bIndex === -1) return -1
    if (aIndex === -1 && bIndex !== -1) return 1
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
    return 0
  })
}

export default getFacilities
